import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://oeghrgfqyecteptrylyt.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9lZ2hyZ2ZxeWVjdGVwdHJ5bHl0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ2NzI5MjQsImV4cCI6MjA5MDI0ODkyNH0.WBnokJ552dN2pbNc1FgDRaYlxhWBWCcpAwYI1AyJnwQ';

export const supabase = createClient(supabaseUrl, supabaseKey);
